import { useTranslation } from 'react-i18next'
import { EditSolidIcon } from '@dhl-ui/icons'
import { Body1, Body2, Box, Card, Grid, H6, IconButton, Link } from '@dhl-ui/components'
import { links } from '~/AppRoutes'
import { useCurrentUser } from '~/common'
import { useUserAccountNumbers } from '~/common/components/accountnumbers'
import type { User } from '~/modules/users/model'

type Props = {
  user: User
  onEdit: () => void
}

export const ViewUserOrganisationCard = ({ user, onEdit }: Props) => {
  const { id, userType, organisationName, parcelShopName, organisationId, parcelShopPsfKey } = user
  const { hasRole } = useCurrentUser()
  const { t } = useTranslation()
  const { userAccountNumbers } = useUserAccountNumbers(userType, id)

  const organisationLocation =
    parcelShopName && parcelShopPsfKey && hasRole('PARCEL_SHOPS')
      ? links.servicePointDetailsLink(parcelShopPsfKey)
      : organisationId && hasRole('ORGANISATIONS')
        ? links.organisationDetailsLink(organisationId)
        : undefined

  const editButtonClick = () => {
    onEdit()
  }

  return (
    <Card>
      <Card.Header
        title={t('admin.usersPage.organisationDetailsView.titleText')}
        endNode={
          <IconButton aria-label="edit organisation" onClick={() => editButtonClick()}>
            <EditSolidIcon />
          </IconButton>
        }
      />
      <Card.Content>
        <Grid>
          <H6>{t('admin.usersPage.organisationDetailsView.details')}</H6>
        </Grid>
        <Grid container direction="column" justifyContent="space-between" alignItems="stretch">
          <Grid>
            <Box marginTop={1}>
              <Body2 variant="tertiary">{t('admin.usersPage.organisationDetailsView.OrganisationCompany')}</Body2>
              {organisationLocation ? (
                <Link title={parcelShopName ?? organisationName ?? ''} href={organisationLocation}>
                  {parcelShopName ?? organisationName}
                </Link>
              ) : (
                <Body1>{parcelShopName ?? organisationName}</Body1>
              )}
            </Box>
          </Grid>
          <Grid>
            <Box marginTop={1}>
              <Body2 variant="tertiary">
                {t('admin.usersPage.organisationDetailsView.accountNumber').toUpperCase()}
              </Body2>
              <Body1>{userAccountNumbers.join(', ')}</Body1>
            </Box>
          </Grid>
        </Grid>
      </Card.Content>
    </Card>
  )
}
